import { authFetch } from '@/lib/auth-fetch';
import { getApiBaseUrl } from '@/services/apiClient';

interface IntercomUserSignatureResponse {
  userHash: string;
}

export const intercomService = {
  async fetchUserSignature(): Promise<string> {
    const apiBaseUrl = getApiBaseUrl();
    const response = await authFetch(`${apiBaseUrl}/intercom/user-signature`);

    if (!response.ok) {
      throw new Error(`Failed to fetch Intercom user signature: ${response.status}`);
    }

    const data: IntercomUserSignatureResponse = await response.json();
    return data.userHash;
  },
};
